const tgr = [
    {
        depth2: 'IBK모임 서비스',
        depth3: '안내화면',
        depth4: '',
        depth5: '',
        name: '안내화면',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0014-F',
        plan: '26.01.27',
        end: '26.01.27',
        user: '박서연',
        state: '완료',
        etc: '26.03.24 디자인 수정',
        uxw: true,
    },       
    {
        depth2: 'IBK모임 서비스',
        depth3: '초대메일 수신',
        depth4: '',
        depth5: '',
        name: '모바일 브랜치',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0000-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '26.03.26 디자인 변경',
        uxw: true,
    },   
    {
        depth2: 'IBK모임 서비스',
        depth3: '초대 수락',
        depth4: '',
        depth5: '',
        name: '초대 수락',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0013-F',
        plan: '26.01.22',
        end: '26.01.22',
        user: '박서연',
        state: '완료',
        etc: '26.03.26 디자인 변경',
        uxw: true,
    },       
    {
        depth2: 'IBK모임 서비스',
        depth3: '휴대폰 인증',
        depth4: '비대면 실명확인',
        depth5: '',
        name: '본인인증동의',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0001-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '',
        uxw: true,
    }, 
    {
        depth2: 'IBK모임 서비스',
        depth3: '휴대폰 인증',
        depth4: '비대면 실명확인',
        depth5: '약관동의',
        name: '약관동의',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0002-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '26.03.24 서비스명 변경',
        uxw: true,
    },
    {
        depth2: 'IBK모임 서비스',
        depth3: '휴대폰 인증',
        depth4: '비대면 실명확인',
        depth5: '약관동의',
        name: '모임가입 신청',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0003-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '',
        uxw: true,
    },     
    {
        depth2: 'IBK모임 서비스',
        depth3: '내 모임',
        depth4: '',
        depth5: '',
        name: '내 모임 목록',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0004-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '26.03.24 서비스명 변경',
        uxw: true,
    },       
    {
        depth2: 'IBK모임 서비스',
        depth3: '내 모임',
        depth4: '',
        depth5: '',
        name: '모임 상세',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0005-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '26.03.24 서비스명 변경',
        uxw: true,
    },       
    {
        depth2: 'IBK모임 서비스',
        depth3: '내 모임',
        depth4: '모임 상세',
        depth5: '',
        name: '회비리포트',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0006-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '',
        uxw: true,
    },    
    {
        depth2: 'IBK모임 서비스',
        depth3: '내 모임',
        depth4: '모임 상세',
        depth5: '',
        name: '모임연결계좌',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0007-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '',
        uxw: true,
    },

    {
        depth2: 'IBK모임 서비스',
        depth3: '내 모임',
        depth4: '모임 상세',
        depth5: '',
        name: '모임원 보기',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0008-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '',
        uxw: true,
    },      
    {
        depth2: 'IBK모임 서비스',
        depth3: '내 모임',
        depth4: '모임 상세',
        depth5: '',
        name: '모임주 변경',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0009-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '',
        uxw: true,
    },   
    {
        depth2: 'IBK모임 서비스',
        depth3: '내 모임',
        depth4: '모임 상세',
        depth5: '',
        name: '모임주 변경 (투표 완료)',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0010-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: 'IBK모임 서비스',
        depth3: '내 모임',
        depth4: '모임 상세',
        depth5: '',
        name: '모임 나가기',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0011-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '',
        uxw: true,
    }, 
    {
        depth2: 'IBK모임 서비스',
        depth3: '내 모임',
        depth4: '모임 상세',
        depth5: '',
        name: '모임주 변경, 취소, 완료 안내 화면',
        type: 'PAGE',
        dir: 'tgr',
        id: 'SC-TGR-0012-F',
        plan: '25.12.05',
        end: '25.12.05',
        user: '박서연',
        state: '완료',
        etc: '',
        uxw: true,
    },                
]     

export default tgr
